export default
{
  pic: ['Foto', 'Photo', 'Foto'],
  of: ['de', 'of', 'de'],
  notConfig: [
    'Esse é um espaço para você dividir com sua consultora de imagem o que quiser: referências, look do dia, compras e até pequenas mensagens',
    'This is a space for you to share with your image consultant whatever you want: references, look of the day, purchases and even small messages',
    'Este es un espacio para que compartas con tu asesor de imagen lo que quieras: referencias, look del día, compras e incluso pequeños mensajes.'
  ],
  notConfSendLink: ['Clique aqui', 'Click here', 'Haga clic aquí'],
  notConfSendMessage: [
    ' e envie uma mensagem no WhatsApp!',
    ' and send a message on WhatsApp!',
    ' y envía un mensaje por WhatsApp!'
  ],
  rememberYou: [
    'Lembrei de você',
    'Remember You',
    'Me acordé de ti'
  ],
  buttonUploadText: [
    'Anexar Imagem',
    'Attach Image',
    'Adjuntar imagen'
  ],
  addImageOrTextMessage: [
    'Adicione uma imagem e/ou texto, por favor!',
    'Add an image and/or text, please!',
    '¡Agrega una imagen y/o texto, por favor!'
  ],
  like: [
    'Gostei',
    'Liked',
    'me gustó'
  ],
  dislike: [
    'Não gostei',
    'Disliked',
    'No me gustó'
  ],
  comment: [
    'Comentario',
    'Comment',
    'Comentario'
  ],
  limitReached: [
    'Você já atingiu o limite de 20 itens este mês.',
    'You have already reached the limit of 20 items this month.',
    'Ya has alcanzado el límite de 20 artículos este mes.'
  ],
  sendSuccess: [
    'Lembrei de você enviado com sucesso!',
    'I remembered you sent successfully!',
    '¡Recordé que enviaste exitosamente!'
  ]
}



// WEBPACK FOOTER //
// ./src/constants/RememberYou.js